<template>
  <v-container>
    <v-btn elevation="2" fab absolute small @click="$router.go(-1)" v-show="!$vuetify.breakpoint.smAndDown">
      <v-icon color="primary">mdi-arrow-left-bold</v-icon>
    </v-btn>

    <v-row dense>
      <v-col class="text-h3" align="center">
        Novinky
      </v-col>
    </v-row>
    <v-row dense>
      <v-col class="text-h5" align="center">
        Čo je nové?
      </v-col>
    </v-row>

    <v-row justify="space-between" align="center" no-gutters>
      <v-col cols="12" md="6" class="text-left" align-self="start">
        <v-text-field v-model="search" label="Vyhladaj" clearable></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="4" align="right" class="d-flex align-center justify-end">
        <v-btn-toggle v-model="view_type" mandatory borderless dense class="mr-4">
          <v-btn value="grid" icon>
            <v-icon>mdi-view-grid-outline</v-icon>
          </v-btn>
          <v-btn value="list" icon>
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
        </v-btn-toggle>

        <v-btn v-if="filter_favorite" text color="amber amber-darken-4" @click="filter_favorite = false">
          Iba oblubene &nbsp;<v-icon>mdi-star</v-icon>
        </v-btn>

        <v-btn v-else text color="amber amber-darken-4" @click="filter_favorite = true">
          Iba oblubene &nbsp;<v-icon>mdi-star-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-row align="stretch" v-if="view_type === 'grid'">
          <v-col v-for="item in items" :key="`${item.type}-${item.id}`" cols="12" md="6" lg="4" class="d-flex">
            <v-card hover class="flex-grow-1 d-flex flex-column rounded-lg" outlined :to="getLink(item)">
              <v-card-title class="d-flex justify-space-between align-start text-h6 primary--text word-break-normal pt-4">
                <span style="word-break: break-word; line-height: 1.3;">{{ getItemTitle(item) }}</span>
                <div class="d-flex align-center ml-2">
                  <v-icon v-if="item.private" small>mdi-file-hidden</v-icon>
                </div>
              </v-card-title>

              <v-card-subtitle class="pb-2 mt-1 d-flex align-center flex-wrap">
                <v-chip x-small label class="font-weight-bold mr-2" color="blue lighten-5" text-color="blue darken-2">
                  {{ getTypeLabel(item) }}
                </v-chip>

                <v-chip
                  v-if="item.not_voted_questions_count"
                  color="red lighten-5"
                  text-color="red darken-2"
                  x-small
                  label
                  class="font-weight-bold"
                >
                  Nehlasované: {{ item.not_voted_questions_count }}
                </v-chip>
                <v-chip v-else color="green lighten-5" text-color="green darken-2" x-small label class="font-weight-bold">
                  <v-icon left x-small>mdi-check</v-icon>
                  Všetko odhlasované
                </v-chip>
              </v-card-subtitle>

              <v-card-text class="flex-grow-1">
                <div class="text-body-2 grey--text text--darken-1">
                  {{ getItemSubtitle(item) }}
                </div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="justify-end pa-3 grey lighten-5" @click.stop.prevent>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click.stop.prevent="item.user_favorite ? removeFavorite(item) : addFavorite(item)">
                      <v-icon :color="item.user_favorite ? 'amber darken-4' : 'grey lighten-1'">
                        {{ item.user_favorite ? 'mdi-star' : 'mdi-star-outline' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.user_favorite ? 'Zrušiť obľúbené' : 'Pridať obľúbené' }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-list v-else flat class="transparent">
          <v-list-item-group color="primary">
            <v-card
              v-for="item in items"
              :key="`${item.type}-${item.id}`"
              class="mb-3 rounded-lg flex-grow-1 d-flex flex-column"
              outlined
              hover
              :to="getLink(item)"
            >
              <div class="d-flex align-center pa-2 w-100">
                <div class="flex-grow-1 px-2 overflow-hidden">
                  <div class="d-flex align-center flex-wrap">
                    <span class="text-subtitle-1 font-weight-bold primary--text mr-2 text-truncate" style="max-width: 70%;">
                      {{ getItemTitle(item) }}
                    </span>
                    <v-icon v-if="item.private" small class="mr-2">mdi-file-hidden</v-icon>

                    <v-chip x-small label class="font-weight-bold mr-2" color="blue lighten-5" text-color="blue darken-2">
                      {{ getTypeLabel(item) }}
                    </v-chip>

                    <v-chip
                      v-if="item.not_voted_questions_count"
                      color="red lighten-5"
                      text-color="red darken-2"
                      x-small
                      label
                      class="font-weight-bold mr-2"
                    >
                      Nehlasované: {{ item.not_voted_questions_count }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green lighten-5"
                      text-color="green darken-2"
                      x-small
                      label
                      class="font-weight-bold mr-2"
                    >
                      <v-icon left x-small>mdi-check</v-icon>
                      Všetko odhlasované
                    </v-chip>
                  </div>

                  <div class="text-caption grey--text text--darken-1 mt-1 text-truncate">
                    {{ getItemSubtitle(item) }}
                  </div>
                </div>

                <div class="d-flex align-center px-2" @click.stop.prevent>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click.stop.prevent="item.user_favorite ? removeFavorite(item) : addFavorite(item)">
                        <v-icon :color="item.user_favorite ? 'amber darken-4' : 'grey lighten-1'">
                          {{ item.user_favorite ? 'mdi-star' : 'mdi-star-outline' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.user_favorite ? 'Zrušiť obľúbené' : 'Pridať obľúbené' }}</span>
                  </v-tooltip>
                </div>
              </div>
            </v-card>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();

export default {
  name: "News",
  inheritAttrs: true,

  data() {
    return {
      categories: [],
      polls: [],
      pollQuestions: [],

      filter_favorite: false,
      search: "",
      sort: ["news_order"],
      view_type: "grid",

      timeout: undefined
    };
  },

  computed: {
    ...mapGetters("auth", [
      "isAuthenticated",
      "username",
      "isVerified",
      "isVerifiedBank",
      "isVerifiedSmsEmail",
      "isStaff",
      "getMemberStatus",
      "firstName",
      "lastName",
      "gender",
      "user_id"
    ]),

    ...mapGetters("settings", ["getSettings"]),

    items() {
      const categoriesTmp = this.categories.map((obj) => ({ ...obj, type: "category" }));
      const pollsTmp = this.polls.map((obj) => ({ ...obj, type: "poll" }));
      const pollQuestionsTmp = this.pollQuestions.map((obj) => ({ ...obj, type: "pollQuestion" }));

      const tmp = categoriesTmp.concat(pollsTmp, pollQuestionsTmp);
      tmp.sort((a, b) => (a.news_order || 0) - (b.news_order || 0));

      return tmp;
    }
  },

  watch: {
    filter_favorite() {
      localStorage.setItem("news_filter_favorite", this.filter_favorite ? "true" : "false");
      this.getItems();
    },

    search() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.getItems();
      }, 500);
    },

    view_type(val) {
      localStorage.setItem("news_view_type", val);
    }
  },

  mounted() {
    const savedViewType = localStorage.getItem("news_view_type");
    if (savedViewType) {
      this.view_type = savedViewType;
    }

    if (localStorage.getItem("news_filter_favorite") === "true") {
      this.filter_favorite = true;
    }

    this.getItems();
  },

  methods: {
    getItemTitle(item) {
      return item.name || item.first_field || "";
    },

    getItemSubtitle(item) {
      if (item.type === "pollQuestion") {
        return item.poll_name || item.poll_category_name || "Otazka";
      }

      if (item.type === "poll") {
        return item.poll_category_name || "Rubrika";
      }

      return item.sub_name || "Kategoria";
    },

    getTypeLabel(item) {
      if (item.type === "pollQuestion") {
        return "Otazka";
      }

      if (item.type === "poll") {
        return "Rubrika";
      }

      return "Kategoria";
    },

    getLink(item) {
      if (item.url) {
        return item.url;
      }

      switch (item.type) {
        case "category":
          return "/poll_category/" + item.id;
        case "poll":
          return "/poll_category/" + item.poll_category + "/poll/" + item.id + "/";
        case "pollQuestion":
          return "/poll_category/" + item.poll_category + "/poll/" + item.poll + "/#" + item.id;
        default:
          return "";
      }
    },

    removeFavorite(item) {
      switch (item.type) {
        case "category":
          apiService.generalPollCategoryRemoveFavorite(item.id).then(() => {
            this.getItems();
          });
          break;
        case "poll":
          apiService.generalPollRemoveFavorite(item.id).then(() => {
            this.getItems();
          });
          break;
        case "pollQuestion":
          apiService.generalPollQuestionRemoveFavorite(item.id).then(() => {
            this.getItems();
          });
          break;
        default:
          this.getItems();
      }
    },

    addFavorite(item) {
      switch (item.type) {
        case "category":
          apiService.generalPollCategoryAddFavorite(item.id).then(() => {
            this.getItems();
          });
          break;
        case "poll":
          apiService.generalPollAddFavorite(item.id).then(() => {
            this.getItems();
          });
          break;
        case "pollQuestion":
          apiService.generalPollQuestionAddFavorite(item.id).then(() => {
            this.getItems();
          });
          break;
        default:
          this.getItems();
      }
    },

    getItems() {
      const limit = 0;
      const offset = 0;
      const filters = [];

      if (this.filter_favorite) {
        filters.push(["favorite", 1]);
      }

      filters.push(["news_include", 1]);
      filters.push(["news_date_to", new Date().toISOString()]);

      apiService.getGeneralPollCategories(this.sort, this.search, limit, offset, filters).then((response) => {
        this.categories = response.results;
      });

      apiService.getGeneralPolls(this.sort, this.search, limit, offset, filters).then((response) => {
        this.polls = response.results;
      });

      apiService.getGeneralPollQuestions(this.sort, this.search, limit, offset, filters).then((response) => {
        this.pollQuestions = response.results;
      });
    }
  }
};
</script>
